"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayFromOption = exports.listFromOption = exports.fromOption = exports.onSome = exports.mapO = exports.some = exports.none = void 0;
const immutable_1 = require("immutable");
const sum_1 = require("./sum");
const none = function () { return (0, sum_1.inl)({}); };
exports.none = none;
const some = function (v) { return (0, sum_1.inr)(v); };
exports.some = some;
const mapO = (f, o) => o.kind == "r" ? (0, exports.some)(f(o.v)) : (0, exports.none)();
exports.mapO = mapO;
exports.onSome = exports.mapO;
const fromOption = function (def, o) {
    return o.kind == "r" ? o.v : def;
};
exports.fromOption = fromOption;
const listFromOption = (x) => x.kind == "l" ? (0, immutable_1.List)() : (0, immutable_1.List)().push(x.v);
exports.listFromOption = listFromOption;
const arrayFromOption = (x) => x.kind == "l" ? [] : [x.v];
exports.arrayFromOption = arrayFromOption;
